import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
// import ApiRequestHelper from './api/lib/api-request.helper';
import App from './app';
import helpers from './helpers'
import store from './redux/configure-store';

// include all css styles needed by the application here
// NOTE: make sure to include antd css before main css.
// only include main css files once (otherwise we can get out of order results)
import 'antd/dist/antd.css';
import './styles/_antd-overrides.scss';
import './styles/main.scss';



// ApiRequestHelper.setAxiosDefaults({ withCredentials: true });

helpers.state.initReduxStore(store);


let basename = process.env.PUBLIC_URL || null;

ReactDOM.render(
  <BrowserRouter basename={basename}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);

